const isHubSpotWindow = obj => {
  return typeof obj === 'object' && obj !== null && 'bender' in obj && typeof obj.bender === 'object' && obj.bender !== null && 'currentProject' in obj.bender && typeof obj.bender.currentProject === 'string';
};
export const getBenderProject = win => {
  if (isHubSpotWindow(win.hubspot)) {
    var _win$hubspot$bender;
    return (_win$hubspot$bender = win.hubspot.bender) === null || _win$hubspot$bender === void 0 ? void 0 : _win$hubspot$bender.currentProject;
  }
  return undefined;
};